import { Paper, Table, TableContainer, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@mui/material'
import { isEmpty } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { NoData } from 'components'
import Spinner from './Spinner'

const StyledTableContainer = styled(TableContainer)`
  border-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const StyledLoadingBox = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  margin: 1rem;
`

const StyledTh = styled(TableCell)`
  && {
    width: ${({ width }) => width ?? '10vw'};
    padding: 12px;
    white-space: nowrap;
  }
`

const StyledTd = styled(TableCell)`
  && {
    padding: 12px;
  }
`

const StyledTablePagination = styled(TablePagination)`
  position: relative;
  bottom: 0;
  background: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  p {
    margin-bottom: 0;
  }
`

function BasicTable({ isLoading, columns, dataSrc, pagination }) {
  const { t } = useTranslation()

  const tableHeader = (
    <TableHead>
      <TableRow>
        {columns.map((col) => (
          <StyledTh key={col.key} sx={{ fontWeight: 900 }} width={col.width}>
            {col.title}
          </StyledTh>
        ))}
      </TableRow>
    </TableHead>
  )

  if (isLoading) {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="simple table">{tableHeader}</Table>
        <StyledLoadingBox>
          <Spinner />
        </StyledLoadingBox>
      </TableContainer>
    )
  }

  return (
    <>
      <StyledTableContainer component={Paper}>
        <Table aria-label="simple table">
          {tableHeader}
          <TableBody>
            {dataSrc.map((row, i) => (
              <TableRow key={i} component="tr" scope="row">
                {columns.map((col) => (
                  <StyledTd key={col.key}>{col.render?.(row[col.key], row) || row[col.key]}</StyledTd>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {isEmpty(dataSrc) && <NoData />}
      </StyledTableContainer>
      {pagination && (
        <StyledTablePagination
          component="div"
          rowsPerPage={10}
          count={pagination.count}
          page={pagination.current - 1}
          onPageChange={(_, page) => pagination.onPageChange(page + 1)}
          rowsPerPageOptions={[10]}
        />
      )}
    </>
  )
}

export default BasicTable
